import { FormCard, FormItem } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { Form as AntdForm, Input } from 'antd'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

const ToleranceSettingsTab = () => {
  const { t } = useTranslation()

  return (
    <FormCard title={t('TOLERANCE_SETTINGS')}>
      <DividerSpace />
      <FormItem
        label={
          <Text>
            {t('NOT_YET_CLOCKED_IN')}
          </Text>
        }
      >
        <FormItem name="notYetClockedIn">
          <Input type="number" suffix={t('MINUTES')} />
        </FormItem>
        <GrayText>{t('NOT_YET_CLOCKED_IN_INFO')}</GrayText>
      </FormItem>
      <FormItem
        label={
          <Text>
            {t('CLOCKED_IN_EARLY')}
          </Text>
        }
      >
        <FormItem name="clockInEarly">
          <Input type="number" suffix={t('MINUTES')} />
        </FormItem>
        <GrayText>{t('CLOCKED_IN_EARLY_INFO')}</GrayText>
      </FormItem>
      <FormItem
        label={
          <Text>
            {t('CLOCKED_IN_LATE')}
          </Text>
        }
      >
        <FormItem name="clockInLate">
          <Input type="number" suffix={t('MINUTES')} />
        </FormItem>
        <GrayText>{t('CLOCKED_IN_LATE_INFO')}</GrayText>
      </FormItem>
      <FormItem
        label={
          <Text>
            {t('CLOCKED_OUT_EARLY')}
          </Text>
        }
      >
        <FormItem name="clockOutEarly">
          <Input type="number" suffix={t('MINUTES')} />
        </FormItem>
        <GrayText>{t('CLOCKED_OUT_EARLY_INFO')}</GrayText>
      </FormItem>
      <FormItem
        label={
          <Text>
            {t('CLOCKED_OUT_LATE')}
          </Text>
        }
      >
        <FormItem name="clockOutLate">
          <Input type="number" suffix={t('MINUTES')} />
        </FormItem>
        <GrayText>{t('CLOCKED_OUT_LATE_INFO')}</GrayText>
      </FormItem>
      <FormItem
        label={
          <Text>
            {t('MISSED')}
          </Text>
        }
      >
        <FormItem name="missed">
          <Input type="number" suffix={t('MINUTES')} />
        </FormItem>
        <GrayText>{t('MISSED_INFO')}</GrayText>
      </FormItem>
      <FormItem
        label={
          <Text>
            {t('DURATION_MISMATCH')}
          </Text>
        }
      >
        <FormItem name="durationMismatched">
          <Input type="number" suffix={t('MINUTES')} />
        </FormItem>
        <GrayText>{t('DURATION_MISMATCH_INFO')}</GrayText>
      </FormItem>
    </FormCard>
  )
}

const GrayText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const DividerSpace = styled.div``

export default ToleranceSettingsTab
